import { render, staticRenderFns } from "./dots.vue?vue&type=template&id=8c891aa6&scoped=true"
import script from "./dots.vue?vue&type=script&lang=js"
export * from "./dots.vue?vue&type=script&lang=js"
import style0 from "./dots.vue?vue&type=style&index=0&id=8c891aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c891aa6",
  null
  
)

export default component.exports